export interface SanctuaireShopItem {
  bit: number
  cost: number
  kind: 'title' | 'perk'
  titleId?: string
  nameFr: string
  nameEn: string
  descFr: string
  descEn: string
  rarity: 'common' | 'rare' | 'epic' | 'legendary'
}

/** Bits persistés dans `player.stats._sanctShopBits` (OR monotonique côté serveur). */
export const SANCT_SHOP_STATS_KEY = '_sanctShopBits' as const

export const SANCTUAIRE_SHOP_ITEMS: SanctuaireShopItem[] = [
  {
    bit: 0,
    cost: 42,
    kind: 'title',
    titleId: 'sanctuaire_strate_initie',
    nameFr: 'Titre : Initié des strates',
    nameEn: 'Title: Strata Initiate',
    descFr: 'Montre que tu as investi tes premiers éclats dans le sanctuaire.',
    descEn: 'Shows you invested your first shards in the sanctuary.',
    rarity: 'common',
  },
  {
    bit: 1,
    cost: 115,
    kind: 'title',
    titleId: 'sanctuaire_gouffre_parieur',
    nameFr: 'Titre : Parieur du gouffre',
    nameEn: 'Title: Abyss Gambler',
    descFr: 'Pour ceux qui enchaînent les descentes sans trembler.',
    descEn: 'For those who chain descents without flinching.',
    rarity: 'rare',
  },
  {
    bit: 2,
    cost: 235,
    kind: 'title',
    titleId: 'sanctuaire_maitre_sanctuaire',
    nameFr: 'Titre : Maître du sanctuaire',
    nameEn: 'Title: Sanctuary Master',
    descFr: 'Preuve d’une longue fidélité aux strates cachées.',
    descEn: 'Proof of long loyalty to the hidden strata.',
    rarity: 'epic',
  },
  {
    bit: 3,
    cost: 420,
    kind: 'title',
    titleId: 'sanctuaire_architecte_teral',
    nameFr: 'Titre : Architecte Téral',
    nameEn: 'Title: Tera Architect',
    descFr: 'Le sommet cosmétique réservé aux plus téméraires.',
    descEn: 'The top cosmetic reward for the boldest climbers.',
    rarity: 'legendary',
  },
  {
    bit: 4,
    cost: 180,
    kind: 'perk',
    nameFr: 'Lanterne du sanctuaire',
    nameEn: 'Sanctuary lantern',
    descFr: '+2 % d’efficacité hors ligne (cumul sanctuaire max +4 %).',
    descEn: '+2% offline efficiency (sanctuary stack max +4%).',
    rarity: 'rare',
  },
  {
    bit: 5,
    cost: 95,
    kind: 'perk',
    nameFr: 'Sac du pèlerin',
    nameEn: 'Pilgrim’s pack',
    descFr: '+1 reroll de draft au début de chaque descente.',
    descEn: '+1 draft reroll at the start of every descent.',
    rarity: 'common',
  },
]

export const SANCT_OFFLINE_BONUS_PER_LANTERN_PCT = 2
export const SANCT_OFFLINE_BONUS_MAX_PCT = 4

export function readSanctOfflineBonusPct(stats: Record<string, unknown> | undefined): number {
  const bits = readSanctShopBits(stats)
  if (!hasSanctShopBit(bits, 4)) return 0
  return SANCT_OFFLINE_BONUS_PER_LANTERN_PCT
}

export function readSanctShopBits(stats: Record<string, unknown> | undefined): number {
  if (!stats) return 0
  const v = Math.floor(Number(stats[SANCT_SHOP_STATS_KEY] ?? 0))
  return Number.isFinite(v) && v >= 0 ? v : 0
}

export function hasSanctShopBit(bits: number, bit: number): boolean {
  return (bits & (1 << bit)) !== 0
}

export function withSanctShopBit(bits: number, bit: number): number {
  return bits | (1 << bit)
}
